module.exports = __webpack_public_path__ + "img/RPA4.2caad34d.png";